export default status => {
  if (status === 'Active') {
    return '#ffe0b1';
  } if (status === 'Deactivated') {
    return '#e2e2e2';
  } return '#e2e2e2';
};
